export const TITLES = [
    { id: 1, title: "Mr" },
    { id: 2, title: "Ms" },
    { id: 3, title: "Mrs" },
    { id: 4, title: "Miss" }
];

export const RECIPIENT_TYPES = [
    { id: 1, type: "Client" },
    { id: 2, type: "Site" }
]

export const INVOICE_DOWNLOAD_TYPES = [
    { id: 1, downloadType: "Invoice" },
    { id: 2, downloadType: "PaymentApplication" },
    { id: 3, downloadType: "WorkcardWithAllImages" },
    { id: 4, downloadType: "WorkcardWithPaymentCardOnly" },
    { id: 5, downloadType: "PaymentCardOnly" }
]

export const SUBMISSION_STATUS = {
    1: "Pending",
    2: "Approved",
    3: "Site Revisit",
    4: "Site Attention"
};

export const INVOICE_RETURN_REASONS = [
    { id: 1, reason: "Signature" },
    { id: 2, reason: "Payment Form" },
    { id: 3, reason: "Both" },
    { id: 4, reason: "Other" }
]